import { GetProcessesResponseBodyType } from "@intelligems/ig-types";
import { QueryObserverOptions, useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { processesKeys } from "../queryKeys";

const getProcesses = async () => {
  const resp = await api.get<GetProcessesResponseBodyType>(
    `/v2/organizations/processes`
  );
  return resp.data;
};

export const useGetProcesses = (
  options?: QueryObserverOptions<GetProcessesResponseBodyType, Error>
) => {
  const org = useGetOrg();
  return useQuery<GetProcessesResponseBodyType, Error>({
    queryKey: processesKeys.one(org.data.org.id),
    queryFn: async () => getProcesses(),
    refetchInterval: 60 * 1000,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    enabled: import.meta.env.VITE_STAGE !== "local",
    ...options,
  });
};
